import * as React from 'react'
import type { ShortCutItemsPropsType } from '../../models/Discover'
import { TagCardRow } from '@components/Tag/TagCardRow'

function DiscoverNav (props: ShortCutItemsPropsType): React.ReactNode {
  return (
    <TagCardRow tags={props.items}/>
  )
}

export default DiscoverNav
